import { render, staticRenderFns } from "./Boolean-question.vue?vue&type=template&id=64002eba"
import script from "./Boolean-question.vue?vue&type=script&lang=js"
export * from "./Boolean-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports